import { TypeformEmbed } from '@psyomics/ui-common';
import { Header, Text, Woman4 } from '@psyomics/ui-components';
import { Trans, useTranslation } from 'react-i18next';

import { IllustrationWithArc } from '../../../shared/components/header-illustration-layout/header-illustration-layout';
import { useReferralInviteQuery } from '../../referral/hooks/use-referral-invite-query';

const TYPEFORM_END_QUESTIONNAIRE_PATIENT_FEEDBACK = 'MsXUWjnX';

const createLink = (href: string, text: string) => (
  <a className="underline" href={href} rel="noopener noreferrer" target="_blank">
    {text}
  </a>
);

const supportLinks = {
  samaritanLink: createLink(
    'https://www.samaritans.org/how-we-can-help/contact-samaritan/talk-us-phone/',
    'Samaritans'
  ),
  shoutLink: createLink('https://www.giveusashout.org/', 'Shout Crisis Text Line'),
  childlineLink: createLink('https://www.childline.org.uk/', 'Childline'),
  nhs111Link: createLink('https://111.nhs.uk/', '111 online'),
};

const EndScreen: React.FC<{ readonly invitePublicId: string }> = ({ invitePublicId }) => {
  const { t } = useTranslation();
  const [invite] = useReferralInviteQuery(invitePublicId);
  const orgCode = invite?.referralSession?.referral?.organisation?.code;

  return (
    <>
      <IllustrationWithArc>
        <Woman4 className="w-full h-auto max-h-[238px]" />
      </IllustrationWithArc>
      <div className="px-6 py-6 space-y-4">
        <Header level="h2">{t('page.questionnaireEnd.header1')}</Header>
        <Text>{t('page.questionnaireEnd.paragraph1')}</Text>
        <div className="space-y-4">
          <Header level="h3">{t('page.questionnaireEnd.header2')}</Header>
          <Text>{t('page.questionnaireEnd.paragraph2')}</Text>
          <Trans
            className="ml-4"
            components={{
              ul: <ul className="space-y-2" />,
              li: <Text tag="li" />,
              strong: <strong />,
              ...supportLinks,
            }}
            i18nKey="page.questionnaireEnd.supportServices"
          />
        </div>
        <div className="space-y-4">
          <Header level="h3">{t('page.questionnaireEnd.header3')}</Header>
          <Trans
            className="ml-4"
            components={{
              ul: <ul className="space-y-2" />,
              li: <Text tag="li" />,
              strong: <strong />,
              nhs111Link: supportLinks.nhs111Link,
            }}
            i18nKey="page.questionnaireEnd.urgentSupport"
          />
        </div>
      </div>
      <TypeformEmbed contract={orgCode} type={TYPEFORM_END_QUESTIONNAIRE_PATIENT_FEEDBACK} />
    </>
  );
};

export { EndScreen };
